const initialState = {
    arrPendingsData: [],
    arrCompletedData: [],
    arrTradesData: [],
    arrBasketData: [],
    gttOrdersData: [],
    sipOrdersData: [],
    allActiveOfs: [],
    allOfsOrders: [],
    siporders: [],
    orderWindow: {
      open: false,
      type: 'BUY',
      trading_symbol: null,
      display_name: null,
      ltp: null,
      exchange: null,
      token: null,
      lotsize: null,
      tick_size: null,
      execution: null,
      bestBid: null,
      bestAsk: null,
      product: null,
      payload: null
    }
  };
  
  export default function reducer(state = initialState, action) {
    switch (action.type) {
      case "SET_PENDING_ORDERS":
        return {
          ...state,
          arrPendingsData: action.payload,
        };
      case "SET_PENDING_ORDER_UPDATE":
        let updatedPendingOrdersData = [];
        const orderUpdate = action.payload;
        const prevPendingOrdersData = [...state.arrPendingsData];
        const index = prevPendingOrdersData.findIndex(
          ({ oms_order_id }) => oms_order_id === orderUpdate.oms_order_id
        );
        if (index === -1) {
          updatedPendingOrdersData = [orderUpdate, ...prevPendingOrdersData];
        } else {
          updatedPendingOrdersData = [...prevPendingOrdersData];
          updatedPendingOrdersData.splice(index, 1, orderUpdate);
        }
        return {
          ...state,
          arrPendingsData: [...updatedPendingOrdersData],
        };
      case "SET_COMPLETED_ORDERS":
        return {
          ...state,
          arrCompletedData: action.payload,
        };
      case "SET_COMPLETED_ORDER_UPDATE":
        let updatedCompletedOrdersData = [];
        const completedOrderUpdate = action.payload;
        const prevCompletedOrdersData = [...state.arrCompletedData];
        const completedOrderIndex = prevCompletedOrdersData.findIndex(
          ({ oms_order_id }) => oms_order_id === completedOrderUpdate.oms_order_id
        );
        if (completedOrderIndex === -1) {
          updatedCompletedOrdersData = [completedOrderUpdate, ...prevCompletedOrdersData];
        }else{
          updatedCompletedOrdersData = [...prevCompletedOrdersData];
          updatedCompletedOrdersData.splice(completedOrderIndex, 1, completedOrderUpdate);
        }
        
        return {
          ...state,
          arrCompletedData: updatedCompletedOrdersData,
        };
      case "SET_TRADES":
        return {
          ...state,
          arrTradesData: action.payload,
        };
      case "SET_BASKET_ORDER":
        return {
          ...state,
          arrBasketData: [...action.payload],
        };
      case "APPEND_TRADES":
        const updatedTradesData = state.arrTradesData.concat(action.payload);
        return {
          ...state,
          arrTradesData: [...updatedTradesData],
        };
      case "SET_GTT_ORDERS":
        return {
          ...state,
          gttOrdersData: [...action.payload],
        };
      case "REMOVE_PENDING_ORDER":
        const orderUpdt = action.payload;
        const newPendingOrdersData = [...state.arrPendingsData];
        const idx = newPendingOrdersData.findIndex(
          ({ oms_order_id }) => oms_order_id == orderUpdt.oms_order_id
        );
        if (idx !== -1) {
          newPendingOrdersData.splice(idx, 1);
        }
        return {
          ...state,
          arrPendingsData: [...newPendingOrdersData],
        };
      case "SET_SIP_ORDERS":
        return {
          ...state,
          sipOrdersData: [...action.payload],
        };
      case "SET_ACTIVE_OFS":
        return {
          ...state,
          allActiveOfs: action.payload,
        };
      case "FETCH_OFS_ORDERS":
        return {
          ...state,
          allOfsOrders: action.payload,
        };
      case "SET_SIP_WEEKLY":
        return {
          ...state,
          siporders:[...action.payload],
        }
      case 'SET_ORDER_WINDOW':
        return {
          ...state,
          orderWindow: action.payload
        };
      case 'CLOSE_ORDER_WINDOW':
        return {
          ...state,
          orderWindow: {
            ...initialState.orderWindow,
            open: false
          }
        };
      case 'UPDATE_ORDER_WINDOW_TYPE':
        return {
          ...state,
          orderWindow: {
            ...state.orderWindow,
            type: action.payload
          }
        };
      default:
        return state;
    }
  }
  